import { getBlockBookingsEmploy } from "services/booking/get-block-bookings-employ";
import { getintervalBookingsemploy } from "services/booking/get-interval-bookings-employ";

export const fetchBookings = async (idsToDelete: number[], startDate: Date, endDate: Date | null = null) => {
    const today = new Date();
    try {
        const bookings = await getBlockBookingsEmploy(idsToDelete, startDate, endDate ?? null);
        if (bookings && bookings.data) {
            const formattedBookingsData = await Promise.all(
                bookings.data.map(async (booking: any) => {
                    const baseBooking = {
                        ...booking,
                        date: new Date(booking.date),
                        block: `${booking?.start_time.substring(0, 5) || ''} - ${booking?.end_time.substring(0, 5) || ''}`,
                        name: `${booking?.kid_first_name} ${booking?.kid_last_name}`,
                        isPrimery: true,
                    };

                    const recurrences = ['recurrence_date_0', 'recurrence_date_1', 'recurrence_date_2', 'recurrence_date_3']
                        .map((key, index) => {
                            const statusKey = `${key}_status`;
                            return booking[key] && booking[statusKey] === 'confirmed'
                                ? {
                                    ...baseBooking,
                                    date: new Date(booking[key]),
                                    isPrimery: false,
                                }
                                : null;
                        })
                        .filter((recurrence) => recurrence !== null && recurrence.date >= today);
                    if (booking.recurrence === "serial") {
                        return recurrences;
                    } else {
                        return [baseBooking];
                    }
                })
            );

            const allBookings = formattedBookingsData.flat();

            return allBookings;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Error fetching bookings for deletion:", error);
        return [];
    }
};

export const fetchBookingsInterval = async (startDate: Date, endDate: Date | null = null) => {
    const today = new Date();
    try {
        const bookings = await getintervalBookingsemploy(startDate, endDate ?? startDate);
        if (bookings && bookings.Kids_bookings_data) {
            const formattedBookingsData = await Promise.all(
                bookings.Kids_bookings_data.map(async (booking: any) => {
                    const baseBooking = {
                        ...booking,
                        date: new Date(booking.date),
                        block: `${booking?.start_time.substring(0, 5) || ''} - ${booking?.end_time.substring(0, 5) || ''}`,
                        name: `${booking?.kid_first_name} ${booking?.kid_last_name}`,
                        isPrimery: true,
                    };

                    const recurrences = ['recurrence_date_0', 'recurrence_date_1', 'recurrence_date_2', 'recurrence_date_3']
                        .map((key, index) => {
                            const statusKey = `${key}_status`;
                            return booking[key] && booking[statusKey] === 'confirmed'
                                ? {
                                    ...baseBooking,
                                    date: new Date(booking[key]),
                                    isPrimery: false,
                                }
                                : null;
                        })
                        .filter((recurrence) => recurrence !== null && recurrence.date >= today);

                    if (booking.recurrence === "serial") {
                        return recurrences;
                    } else {
                        return [baseBooking];
                    }
                })
            );

            const allBookings = formattedBookingsData.flat();
            return allBookings;
        } else {
            return [];
        }
    } catch (error) {
        console.error("Error fetching bookings for deletion:", error);
        return [];
    }
};